export interface 部署型 {
  部署コード: string;
  部署名: string;
  部署名カナ: string;
  入庫即払出フラグ: string;
  外部連携部署コード: string;
  外部連携部署更新バージョン: number;
  HT対象外フラグ: string;
  定点計算フラグ: string;
  在庫照会対象フラグ: string;
  更新バージョン: number;
  削除フラグ: string;
}

export const 部署初期値 = {
  部署コード: '',
  部署名: '',
  部署名カナ: '',
  入庫即払出フラグ: '即払出なし',
  外部連携部署コード: '',
  外部連携部署更新バージョン: 0,
  HT対象外フラグ: '対象',
  定点計算フラグ: '対象外',
  在庫照会対象フラグ: '対象外',
  更新バージョン: 0,
  削除フラグ: '未削除',
};

export const 管理者部署コード: string = '0000000001';
